import { j as t } from "./index.es44.js";
const o = ({ isDark: l = !1, isSmall: e = !1 }) => {
  const s = l ? "#000" : "#fff", a = 32, n = 24, i = [4, 16, 28], r = [3, 12, 21];
  return /* @__PURE__ */ t.jsxs(
    "svg",
    {
      className: "bl-loader",
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      width: e ? n : a,
      height: "8",
      viewBox: `0 0 ${e ? n : a} 8`,
      children: [
        /* @__PURE__ */ t.jsx(
          "circle",
          {
            fill: s,
            stroke: "none",
            cx: e ? r[0] : i[0],
            cy: "4",
            r: e ? r[0] : i[0],
            children: /* @__PURE__ */ t.jsx(
              "animate",
              {
                attributeName: "opacity",
                dur: "1s",
                values: "0;1;0",
                repeatCount: "indefinite",
                begin: "0.1"
              }
            )
          }
        ),
        /* @__PURE__ */ t.jsx(
          "circle",
          {
            fill: s,
            stroke: "none",
            cx: e ? r[1] : i[1],
            cy: "4",
            r: e ? r[0] : i[0],
            children: /* @__PURE__ */ t.jsx(
              "animate",
              {
                attributeName: "opacity",
                dur: "1s",
                values: "0;1;0",
                repeatCount: "indefinite",
                begin: "0.2"
              }
            )
          }
        ),
        /* @__PURE__ */ t.jsx(
          "circle",
          {
            fill: s,
            stroke: "none",
            cx: e ? r[2] : i[2],
            cy: "4",
            r: e ? r[0] : i[0],
            children: /* @__PURE__ */ t.jsx(
              "animate",
              {
                attributeName: "opacity",
                dur: "1s",
                values: "0;1;0",
                repeatCount: "indefinite",
                begin: "0.3"
              }
            )
          }
        )
      ]
    }
  );
};
export {
  o as default
};
//# sourceMappingURL=index.es127.js.map
